import { render, staticRenderFns } from "./SiteAbout.vue?vue&type=template&id=538e55fe&scoped=true"
var script = {}
import style0 from "./SiteAbout.vue?vue&type=style&index=0&id=538e55fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538e55fe",
  null
  
)

export default component.exports